import { apiClient } from './client';

export interface PushSubscription {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
}

export interface PushNotificationApi {
  getVapidPublicKey(): Promise<string>;
  subscribe(subscription: PushSubscription): Promise<void>;
  unsubscribe(endpoint: string): Promise<void>;
  sendTestNotification(title: string, body: string): Promise<void>;
  getSubscriptions(): Promise<any[]>;
}

export const pushNotificationApi: PushNotificationApi = {
  async getVapidPublicKey(): Promise<string> {
    const response = await apiClient.get<{ publicKey: string }>('/push-notifications/vapid-public-key');
    return response.publicKey;
  },

  async subscribe(subscription: PushSubscription): Promise<void> {
    await apiClient.post('/push-notifications/subscribe', { subscription });
  },

  async unsubscribe(endpoint: string): Promise<void> {
    await apiClient.post('/push-notifications/unsubscribe', { endpoint });
  },

  async sendTestNotification(title: string, body: string): Promise<void> {
    await apiClient.post('/push-notifications/send-test', { title, body });
  },

  async getSubscriptions(): Promise<any[]> {
    const response = await apiClient.get<{ subscriptions: any[] }>('/push-notifications/subscriptions');
    return response.subscriptions;
  },
};